import { useRoutes } from "react-router-dom";
import CreateCard from "../../Component/CreateCard.js"
import EditFormRoute from "../../Component/Forms/EditFormRoute.js"

import AddAux from "./ManageAux/Create.js"
import Aux from "./ManageAux/View.js"
import ProtectedRoute from "../RouteProtect.js"


const RoutesArray = [
    {
        path: "*",
        element: <h1>This is 404</h1>
    },
    {
        path: "",
        element:
            (
                <ProtectedRoute requiredRole="admin" routeAuth="carrier" >
                    <Aux />
                </ProtectedRoute>
            )
    },
    {
        path: "/:id",
        element: (
            <ProtectedRoute requiredRole="admin" routeAuth="carrier" >
                <EditFormRoute />
            </ProtectedRoute>
        )
    },
    {
        path: "/addaux",
        element: (
            <ProtectedRoute requiredRole="admin" routeAuth="carrier" >
                <AddAux />
            </ProtectedRoute>
        )
    },
   
];


export default function MangeRoutes() {
    return useRoutes(RoutesArray)
};